import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { Button } from 'reactstrap';

import { EventToolbox } from 'client/utils/event-toolbox';
import { ACTIONS } from 'client/engagement-handlers/inventory-engagement-handler/constants';

import { RETAILER_OFFERS } from 'site-modules/shared/constants/inventory/buy-online-dealers';
import { FINANCING_CAF_ADHESION_PANEL_CREATIVE_ID } from 'site-modules/shared/constants/financing/financing-constants';

import { isCarMax } from 'site-modules/shared/utils/dealer-details-utils';
import { getCommonDeepLink, getDealerLinkWithUTMParams } from 'site-modules/shared/utils/dealership-link-constructor';
import { getCAFPrequalUrl } from 'site-modules/shared/utils/financing/caf-utils';

const getCtaText = (dealer, isTED6504Enabled) => {
  if (!isCarMax(dealer)) {
    return 'Get It Delivered';
  }
  return isTED6504Enabled ? 'Get Pre-qualified' : RETAILER_OFFERS[dealer]?.ctaTitle;
};

export function DeliveryButton({
  vinData,
  zipCode,
  dealerInfo = undefined,
  isProdEnv = false,
  ted6504Recipe = 'ctrl',
  isForceDefault = false,
}) {
  const dealer = get(vinData, 'dealerInfo.displayInfo.parentDealershipName');
  const isTED6504Enabled = ['chal-1', 'chal-2'].includes(ted6504Recipe) && isCarMax(dealer);
  const url = getDealerLinkWithUTMParams({
    vinData,
    dealershipInfo: dealerInfo,
    zipCode,
    dealer: get(vinData, 'dealerInfo.displayInfo.parentDealershipName'),
    isProdEnv,
    isExtended: true,
    getDeepLink: getCommonDeepLink,
    ted6504Recipe,
    isForceDefault,
  });

  const ctaText = getCtaText(dealer, isTED6504Enabled);

  const handleBtnClick = () => {
    if (isTED6504Enabled) {
      EventToolbox.fireCustomEvent(ACTIONS.OPEN_FINANCING_APP, {
        value: ctaText,
        creativeId: FINANCING_CAF_ADHESION_PANEL_CREATIVE_ID,
      });
    } else {
      EventToolbox.fireCustomEvent(ACTIONS.PRICING_BOX_BTN_CLICK, {
        partnerId: get(vinData, 'dealerInfo.rooftopId'),
        value: ctaText,
        type: get(vinData, 'type', '').toLowerCase(),
      });
    }
  };

  return (
    <Button
      size="lg"
      color="blue-50"
      className="px-0_5 py-0_5 text-transform-none w-100 rounded-8 fw-medium"
      href={isTED6504Enabled ? getCAFPrequalUrl(vinData, isProdEnv, ted6504Recipe, isForceDefault) : url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleBtnClick}
    >
      <span className="align-self-center fw-medium">
        {ctaText}
        <i className="icon-open_in_new medium ms-0_25" aria-hidden />
      </span>
    </Button>
  );
}

DeliveryButton.propTypes = {
  vinData: PropTypes.shape({}).isRequired,
  zipCode: PropTypes.string.isRequired,
  dealerInfo: PropTypes.shape({}),
  isProdEnv: PropTypes.bool,
  ted6504Recipe: PropTypes.string,
  isForceDefault: PropTypes.bool,
};
